import type { InventorizationRegisterReading } from '@/features/inventorization/domain/inventorization-reading';
import {
  createInventorizationRegisterId,
  createInventorizationRegisterLabel,
  isDefaultInventorizationRegisterLabel,
} from '@/features/inventorization/domain/inventorization-registers';
import type { PartialInventorizationExtraction } from '@/shared/ocr/inventorize-extraction-contract';

export function mergeInventorizationRegistersWithExtraction(
  registers: InventorizationRegisterReading[],
  extraction?: PartialInventorizationExtraction,
  removedRegisterIds: string[] = [],
) {
  const extractedRegisters = extraction?.registers ?? [];
  const merged = [...registers];

  extractedRegisters.forEach((extractedRegister, index) => {
    const photoRef = extractedRegister.photoRef || createInventorizationRegisterId(index);

    if (removedRegisterIds.includes(photoRef)) {
      return;
    }

    const existingIndex = merged.findIndex(register => register.photoRef === photoRef || register.id === photoRef);
    const targetIndex = existingIndex === -1 ? merged.length : existingIndex;
    const existing = merged[existingIndex];

    merged[targetIndex] = {
      counter: existing?.counter ?? '',
      id: existing?.id ?? photoRef,
      label: chooseRegisterLabel(existing, extractedRegister.name, targetIndex),
      obis: existing?.obis ?? '',
      photoRef,
      tariff: existing?.tariff ?? '',
      unit: existing?.unit ?? '',
    };
  });

  return merged;
}

function chooseRegisterLabel(
  existing: InventorizationRegisterReading | undefined,
  extractedLabel: string | null | undefined,
  index: number,
) {
  if (existing?.label && !isDefaultInventorizationRegisterLabel(existing.label, index)) {
    return existing.label;
  }

  return extractedLabel || existing?.label || createInventorizationRegisterLabel(index);
}
